import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { PartBaqData, PartFileUnits } from './types';

export type UpdatePartForBaqRequestBody = {
  customAttrs?: { name: string; value: string; type: string }[];
  sizeX?: number | null;
  sizeXExtractionUuid?: string | null;
  sizeY?: number | null;
  sizeYExtractionUuid?: string | null;
  sizeZ?: number | null;
  sizeZExtractionUuid?: string | null;
  area?: number | null;
  volume?: number | null;
  units?: PartFileUnits;
};

export const useUpdatePartForBaq: MutationFunction<
  PartBaqData,
  UpdatePartForBaqRequestBody,
  [{ partUuid: string }]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { partUuid } = params;
  const request = useRequest(requestOptions);
  return useMutation(
    (requestBody) => {
      return request<PartBaqData>(`/parts/${partUuid}/baq`, {
        init: {
          method: 'PATCH',
          body: requestBody,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: 'updatePartForBaq',
    },
  );
};
